class Shadow {

  _1 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px -8px " + color,
    };
  };
  _2 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px -6px " + color,
    };
  };
  _3 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px -4px " + color,
    };
  };
  _4 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px -2px " + color,
    };
  };
  _5 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px 0px " + color,
    };
  };
  _6 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px 2px " + color,
    };
  };
  _7 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px 4px " + color,
    };
  };

  _8 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px 6px " + color,
    };
  };
  _9 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px 8px " + color,
    };
  };
  _10 = (color = "#888888") => {
    return {
      boxShadow: "0px 2px 8px 10px " + color,
    };
  };
}

const shadow = new Shadow();
export default shadow;
